import gettext from 'i18n/gettext';
const flow = {
    name: gettext('Buy Gold'),
    cancel: {
        state: 'physical.delivery',
    },
    complete: {
        state: 'physical.delivery',
    },
    steps: [
        {
            key: 'amount',
            state: 'physical.delivery.create.amount',
            heading: gettext('Take Delivery of Goldmoney Bars'),
            label: gettext('Select Bar Size & Quantity'),
        },
        {
            key: 'address',
            state: 'physical.delivery.create.address',
            heading: gettext('Choose Delivery Method'),
            label: gettext('Delivery Method'),
        },
        {
            key: 'review',
            state: 'physical.delivery.create.review',
            cancel: true,
            heading: gettext('Purchase Summary'),
            label: gettext('Review'),
        },
    ],
};
export default flow;



// WEBPACK FOOTER //
// ./src/holding/modules/app/modules/holding/modules/dashboard/modules/physical/states/delivery/create/flow.ts